import { axios } from '@Root/API'

export const getAll = (qualificationAwardId, params) => {
	return axios.get(`qualification-awarded/${qualificationAwardId}/accreditation`, { params })
}
